import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h-100"
}

import {ref, computed, watch} from 'vue';
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {
    OPERATOR_APPLICATION_AUTH_ROUTE_NAME,
    OPERATOR_APPLICATION_ROOT_ROUTE_NAME
} from "~/operatorApplication/ts/router/OperatorApplicationRouteNames";
import {OperatorConfigStore} from "~/operatorApplication/ts/store/OperatorConfigStore";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import OperatorApplicationPlatformFactory from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import {ElConfigProvider} from "element-plus";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import Dictionary from "~/ts/library/Dictionary";
import {useMyRouter} from "~/core-ui/ts/router/useMyRouter";
import 'dayjs/locale/pt'
import 'dayjs/locale/uk'
import 'dayjs/locale/ru'
import OperatorApplicationIframeSender, {
    CLIENT_DIALOG_INIT_ACTION,
    ClientDialogInitActionResponseInterface
} from "~/operatorApplication/ts/OperatorApplicationIframeSender";
import CrossTabMessage from "~/ts/library/crossTabCommunication/talk/CrossTabMessage";
import MyTooltipSingleton from "~/core-ui/vue/ui/my-tooltip/MyTooltipSingleton.vue";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";




import {defineComponent} from "vue";

const __default__ = defineComponent({
    name: "OperatorApplicationRoot",
})

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let initialized = ref(false);
let isAuthorized = computed(() => OperatorAccountStore.isAuthorized.value);

(async () => {
    let brandId = await OperatorApplicationPlatformFactory.getBrandId();
    OperatorConfigStore.SET_BRAND_ID(brandId);
    OperatorApplicationPlatformFactory.initBrand();

    if (window.top !== window) {
        let cabinetResponse;
        try {
            cabinetResponse = await OperatorApplicationIframeSender.send<ClientDialogInitActionResponseInterface>(
                new CrossTabMessage(
                    CLIENT_DIALOG_INIT_ACTION,
                    {},
                    500
                )
            );
            ClientUserdataStore.disableDelayBeforeFetch();
            OperatorAccountStore.cabinetClientDialog.value = cabinetResponse;
        } catch (e) {
        }
    }

    initialized.value = true;
    document.body.classList.add(OperatorConfigStore.brandId.value);
})();

document.addEventListener("click", e => {
    if (e.button == 0) {
        let target = e.target as HTMLElement;
        while (target) {
            if (target.tagName == "A") {
                let href = (target as HTMLLinkElement).getAttribute("href");
                e.preventDefault();
                if (href && href.length) {
                    e.stopPropagation();
                    let url = new URL(href);
                    if (url.protocol === "onlinechat:") {
                        OperatorApplicationPlatform.handleAppUrl(href);
                        return;
                    }
                    OperatorApplicationPlatform.openExternal(href);
                    break;
                }
            }
            target = target.parentElement;
        }
    }
}, {
    capture: true
})


watch(isAuthorized, () => {
    useMyRouter().replace({
        name: isAuthorized.value ? OPERATOR_APPLICATION_ROOT_ROUTE_NAME : OPERATOR_APPLICATION_AUTH_ROUTE_NAME
    });
});


let elemeLocales: Dictionary<any> = {
    'ru': require('element-plus/dist/locale/ru'),
    'en': require('element-plus/dist/locale/en'),
    'ua': require('element-plus/dist/locale/uk'),
    'pt': require('element-plus/dist/locale/pt')
};



return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(ElConfigProvider), {
    locale: _unref(elemeLocales)[_unref(OperatorApplicationConfigInstance).languageId]
  }, {
    default: _withCtx(() => [
      (_unref(initialized))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(), _createBlock(_component_router_view, {
              key: _unref(isAuthorized) ? 'authorized' : 'authForm',
              class: "h-100"
            }))
          ]))
        : _createCommentVNode("", true),
      _createVNode(MyTooltipSingleton)
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})